import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@/presentation/reusables/Dialog';
import DialogExtraCaption from '@/presentation/reusables/Dialog/extras/caption';
import DialogExtraImage from '@/presentation/reusables/Dialog/extras/image';
import iconWarning from '@/assets/illustrations/warning.svg';
import { Creators as Profile } from '@/domain/useCases/getProfile';

const ModalZoom = () => {
  const dispatch = useDispatch();

  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

  const zoomAccount = useSelector(
    (state: any) =>
      state?.profile?.data?.zoomAccount?.active as boolean | undefined
  );

  const [isShow, setIsShow] = useState(false);

  const handlerClose = () => {
    setIsShow(false);
    dispatch(Profile.getProfileZoom());
  };

  useEffect(() => {
    if (timer) clearTimeout(timer);

    setTimer(
      setTimeout(() => {
        if (zoomAccount !== undefined) setIsShow(zoomAccount);
      }, 1000)
    );
  }, [zoomAccount]);

  return (
    <Dialog
      show={isShow}
      styleActions={{ padding: '24px 32px 32px 32px' }}
      handlerClose={handlerClose}
      zIndex={1000}
      maxWidth="360px"
      textButtonA="Ir al tutorial"
      handlerButtonA={() =>
        window.open('https://view.genial.ly/626318165f422800113d83e4', '_blank')
      }
    >
      <DialogExtraImage src={iconWarning} alt="iconWarning" />
      <DialogExtraCaption
        title="Tienes una actualización pendiente en tu cuenta de Zoom"
        subtitle="Vincula tu cuenta de Zoom a UTP y actualiza tu acceso a clases."
      />
    </Dialog>
  );
};

export default ModalZoom;
